import { useMutation, useQueryClient } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { useModal } from 'store/modals';
import { GET_ACCESS_RULES } from '../get-access-rules';
import { deleteAccessRulesAPI } from './api';

export function useDeleteAccessRule({ onSuccess } = {}) {
  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutate, mutateAsync, isLoading, isSuccess, isError } = useMutation(
    (accessRuleId) => deleteAccessRulesAPI(accessRuleId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_ACCESS_RULES, tenantId]);
        if (onSuccess) {
          onSuccess();
        }
        openModal({
          modalType: 'NotificationModal',
          modalProps: { type: 'success', description: 'accessRuleDeletedSuccessfully' },
        });
      },
      onError: () => {
        setTimeout(() => {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'genericErrorMessage',
            },
          });
        }, 100);
      },
    },
  );

  return {
    deleteAccessRule: mutate,
    deleteAccessRuleAsync: mutateAsync,
    mutate,
    mutateAsync,
    isLoading,
    isSuccess,
    isError,
  };
}

